export const PackingResource = {
  name: "Packing",
  path: "/pickpack/packing",
  access: ["read-packings"],
};
